import {
  SET_COUNTRY_OF_TODAY,
  SET_SELECTED_GAME,
  SET_COMPLETED_STATE,
  COUNTRY_GAME_COMPLETED,
  PATCH_GAME_COUNTRY,
  NEIGHBOURS_GAME_COMPLETED,
  PATCH_GAME_NEIGHBOURS,
  CAPITAL_GAME_COMPLETED,
  PATCH_GAME_CAPITAL,
  FLAG_GAME_COMPLETED,
  PATCH_GAME_FLAG,
  SPOKEN_LANGUAGE_GAME_COMPLETED,
  PATCH_GAME_SPOKEN_LANGUAGE,
  POPULATION_GAME_COMPLETED,
  PATCH_GAME_POPULATION,
  CURRENCY_GAME_COMPLETED,
  PATCH_GAME_CURRENCY,
  POPULOUS_CITIES_GAME_COMPLETED,
  PATCH_GAME_POPULOUS_CITIES,
  AREA_GAME_COMPLETED,
  PATCH_GAME_AREA,
} from "../actions/type";
import { GAME_POPULOUS_CITIES } from "../constants/gameTypes";

function createGameInitialState(guessLimit = null) {
  return {
    guessLimit,
    guesses: [],
    searchString: "",
    isCorrect: false,
    completed: false,
  };
}

const initialState = {
  countryOfToday: {},
  gamesOfToday: [],
  selectedGame: {},
  country: createGameInitialState(
    process.env.NODE_ENV === "development" ? 2 : 6,
  ),
  neighbours: createGameInitialState(3),
  capital: createGameInitialState(3),
  flags: createGameInitialState(),
  spokenLanguage: createGameInitialState(),
  population: createGameInitialState(),
  currency: createGameInitialState(),
  populousCites: createGameInitialState(),
  area: createGameInitialState(),
};

const gameReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COUNTRY_OF_TODAY:
      return {
        ...state,
        countryOfToday: action.countryOfToday,
        gamesOfToday: action.gamesOfToday,
        selectedGame: action.gamesOfToday[0],
        neighbours: {
          ...state.neighbours,
          guessLimit:
            action.countryOfToday.borders?.length +
            initialState.neighbours.guessLimit,
        },
        populousCites: {
          ...initialState.populousCites,
          guesses:
            [...action.countryOfToday?.cities.map(({ name }) => name)]?.sort(
              () => Math.random() - 0.5,
            ) ?? [],
        },
      };
    case SET_SELECTED_GAME:
      return { ...state, selectedGame: action.target };
    case SET_COMPLETED_STATE:
      const { key } = action.target;
      return { ...state, [key]: { ...state[key], completed: true } };
    case COUNTRY_GAME_COMPLETED:
      return {
        ...state,
        country: {
          ...state.country,
          completed: true,
          isCorrect: true,
          guesses: [
            ...state.country.guesses,
            {
              Alpha2Code: state.countryOfToday?.Alpha2Code,
              country: state.countryOfToday?.name,
              distance: 0,
              direction: 0,
              percent: 100,
              sizePercent: 100,
            },
          ],
        },
      };
    case PATCH_GAME_COUNTRY:
      return {
        ...state,
        country: {
          ...state.country,
          ...action.payload,
          completed:
            state.country.completed ||
            state.country.guesses.length >= state.country.guessLimit,
        },
      };
    case NEIGHBOURS_GAME_COMPLETED:
      return {
        ...state,
        neighbours: {
          ...state.neighbours,
          completed: true,
          isCorrect: true,
        },
      };
    case PATCH_GAME_NEIGHBOURS:
      return {
        ...state,
        neighbours: {
          ...state.neighbours,
          ...action.payload,
          completed:
            state.neighbours.completed ||
            state.neighbours.guesses.length >= state.neighbours.guessLimit,
        },
      };
    case CAPITAL_GAME_COMPLETED:
      return {
        ...state,
        capital: {
          ...state.capital,
          completed: true,
          isCorrect: true,
        },
      };
    case PATCH_GAME_CAPITAL:
      return {
        ...state,
        capital: {
          ...state.capital,
          ...action.payload,
          completed:
            state.capital.completed ||
            state.capital.guesses.length >= state.capital.guessLimit,
        },
      };
    case FLAG_GAME_COMPLETED:
      return {
        ...state,
        flags: {
          ...state.flags,
          completed: true,
          isCorrect: true,
        },
      };
    case PATCH_GAME_FLAG:
      return {
        ...state,
        flags: {
          ...state.flags,
          ...action.payload,
          completed: state.flags.completed || state.flags.guesses.length >= 8,
        },
      };
    case SPOKEN_LANGUAGE_GAME_COMPLETED:
      return {
        ...state,
        spokenLanguage: {
          ...state.spokenLanguage,
          completed: true,
          isCorrect: true,
        },
      };
    case PATCH_GAME_SPOKEN_LANGUAGE:
      return {
        ...state,
        spokenLanguage: {
          ...state.spokenLanguage,
          ...action.payload,
          completed:
            state.spokenLanguage.completed ||
            state.spokenLanguage.guesses.length >= 8,
        },
      };
    case POPULATION_GAME_COMPLETED:
      return {
        ...state,
        population: {
          ...state.population,
          completed: true,
          isCorrect: true,
        },
      };
    case PATCH_GAME_POPULATION:
      return {
        ...state,
        population: {
          ...state.population,
          ...action.payload,
        },
      };
    case CURRENCY_GAME_COMPLETED:
      return {
        ...state,
        currency: {
          ...state.currency,
          completed: true,
          isCorrect: true,
        },
      };
    case PATCH_GAME_CURRENCY:
      return {
        ...state,
        currency: {
          ...state.currency,
          ...action.payload,
          completed:
            state.currency.completed || state.currency.guesses.length >= 4,
        },
      };
    case POPULOUS_CITIES_GAME_COMPLETED:
      return {
        ...state,
        populousCites: {
          ...state.populousCites,
          completed: true,
          isCorrect: true,
        },
      };
    case PATCH_GAME_POPULOUS_CITIES:
      return {
        ...state,
        populousCites: {
          ...state.populousCites,
          ...action.payload,
        },
      };
    case AREA_GAME_COMPLETED:
      return {
        ...state,
        area: {
          ...state.area,
          completed: true,
          isCorrect: true,
        },
      };
    case PATCH_GAME_AREA:
      return {
        ...state,
        area: {
          ...state.area,
          ...action.payload,
          completed: state.area.completed || state.area.guesses.length >= 4,
        },
      };
    default:
      return state;
  }
};

export default gameReducer;
